"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpLink = exports.trimmedAxiosFetchFactory = void 0;
const client_1 = require("@apollo/client");
const axios_1 = __importDefault(require("axios"));
const axios_fetch_1 = require("./axios-fetch");
function trimmedAxiosFetchFactory(axiosFetch) {
    return async function trimmedAxiosFetch(uri, options) {
        if (options?.body && typeof options.body === "string") {
            const parsedBody = JSON.parse(options.body);
            if (parsedBody?.query && typeof parsedBody.query === "string") {
                // We trim the query string here as well as in the persisted-queries-link to ensure that the hash is consistent across different environments.
                parsedBody.query = parsedBody.query.trim();
            }
            options.body = JSON.stringify(parsedBody);
        }
        return axiosFetch(uri, options);
    };
}
exports.trimmedAxiosFetchFactory = trimmedAxiosFetchFactory;
const axiosFetch = (0, axios_fetch_1.buildAxiosFetch)(axios_1.default);
const trimmedAxiosFetch = trimmedAxiosFetchFactory(axiosFetch);
const httpLink = (uri) => new client_1.HttpLink({
    uri,
    fetch: trimmedAxiosFetch,
    includeExtensions: true,
});
exports.httpLink = httpLink;
//# sourceMappingURL=http-link.js.map